import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectDocument = createSelector(
  [(store: RootState) => store.documentSignerShow.document],
  (data) => data
);
